import React from 'react'
import Permission from '../../../components/Permission'
import { PERMISSIONS } from '../../../constants'
import DiscountCreateV2 from './DiscountCreateV2'

/** `/discounts/create`: o cadastro novo. Só quem tem a permissão de descontos entra (o <Permission> aceita um filho só). */
const DiscountCreate: React.FC = () => (
  <Permission permission={PERMISSIONS.FUEL_DISCOUNTS}>
    <DiscountCreateV2 />
  </Permission>
)

export default DiscountCreate
